<script setup>
	import { onLaunch, onShow, onHide } from '@dcloudio/uni-app'
	import { getCurrentInstance, reactive, ref} from "vue";
	import {selDecorateShopStyleSetApi} from "./api/prod/decorateInfo";


	const { ctx } = getCurrentInstance(); //获取上下文实例，ctx=vue2的this
	
	onLaunch(() => {
		console.log('App Launch!')
		/**
		 * 查询系统配置，bar颜色、字体颜色、背景颜色
		 */
		fnGetDecorateShopStyle();
		/**
		 * H5登录判断
		 */
		// #ifdef H5
		// if (ctx.vuex_hasLogin) {
		// 	//存在则跳转至首页
		// 	uni.reLaunch({
		// 		url: "/pages/index/index",
		// 		success: () => {
		// 			ctx.$u.vuex('vuex_pageCur', 'home');
		// 		}
		// 	})
		// } else {
		// 	//不存在则跳转至登录页
		// 	uni.reLaunch({
		// 		url: "/pages/login/login",
		// 		success: () => {
		// 			//
		// 		}
		// 	})
		// }
		// #endif
		/**
		 * APP登录判断
		 */
		// #ifdef APP-PLUS
		// if (ctx.vuex_hasLogin) {
			//存在则关闭启动页进入首页
			ctx.$u.vuex('vuex_pageCur', 'home');
			uni.reLaunch({
				url: "/pages/index/index",
				success: () => {
					ctx.$u.vuex('vuex_pageCur', 'home');
					plus.navigator.closeSplashscreen();
				}
			})
		// } else {
		// 	//不存在则跳转至登录页
		// 	uni.reLaunch({
		// 		url: "/pages/login/login",
		// 		success: () => {
		// 			plus.navigator.closeSplashscreen();
		// 		}
		// 	})
		// }
		// #endif
	})
	
	
	onShow(() => {
		console.log('App Show!')
		uni.getSystemInfo({
		  success: function (e) {
		    // let custom = uni.getMenuButtonBoundingClientRect();
			const sysInfo = uni.getSystemInfoSync();
			const statusBarHeight = sysInfo.statusBarHeight;
			
			let navBarHeight = 44;
			// #ifdef MP-WEIXIN
			const menuButtonRect = uni.getMenuButtonBoundingClientRect();
			navBarHeight = menuButtonRect.height + (menuButtonRect.top - statusBarHeight) * 2;
			// #endif

			const customNavBarHeight = statusBarHeight + navBarHeight;
			ctx.$u.vuex('vuex_navBarHeight', customNavBarHeight);
			ctx.$u.vuex('vuex_deviceId', sysInfo.deviceId);
		  },
		});
	})
	onHide(() => {
		console.log('App Hide!')
	})
	/**
	 * 获取系统配置主题颜色
	 */
	function fnGetDecorateShopStyle() {
	  let param = {
		platId : ctx.vuex_platId,
		companyId: ctx.vuex_platId,
		shopId: ctx.vuex_platId,
	  };
	  selDecorateShopStyleSetApi(JSON.stringify(param)).then(res => {
	    if(res.retCode == 1 && res.obj != null){
			ctx.$u.vuex('vuex_skinColor', '#'+res.obj.pageColorValue);
			ctx.$u.vuex('vuex_fontColor', '#'+res.obj.headerColorContent);
			ctx.$u.vuex('vuex_backgroundColor', '#'+res.obj.headerColorValue);
		}
	  })
	}
</script>

<style lang="scss">
	/*每个页面公共css */
	/* 注意要写在第一行，注意不能引入至uni.scss，同时给style标签加入lang="scss"属性 */
	@import "common/css/iconfont.css";
	@import "@/uni_modules/uview-plus/index.scss";
	@import "colorui/main.css";
	@import "colorui/layout.css";
	@import "common/css/uni-ui.scss";
	@import "common/css/theme.scss";
  /* 隐藏路径为 pages/component/view/view 页面的 navigationBar */
  .uni-app--showtopwindow [data-page="pages/order/order"] uni-page-head {
    display: none;
  }
</style>
